import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import queryKeys from './queryKeys';
import type { PinterestAccountEntry } from './types';

export interface GetPinterestAccountsParams {
  app: string;
}

export const getPinterestAccounts = async (
  { params }: { params: GetPinterestAccountsParams },
  signal?: AbortSignal,
): Promise<PinterestAccountEntry[]> => {
  const res = await apiClient.get<PinterestAccountEntry[]>(queryKeys.accounts, { params, signal });

  if (isAxiosError(res)) {
    const error = new Error('Get Pinterest Ad Accounts Failed');
    error.cause = res.response?.data;
    return Promise.reject(error);
  }

  return res.data;
};

interface UsePinterestAccountsOptions<TData> {
  params: GetPinterestAccountsParams;
  config?: QueryConfig<typeof getPinterestAccounts, TData>;
}

export const usePinterestAccounts = <TData = PinterestAccountEntry[]>({
  params,
  config,
}: UsePinterestAccountsOptions<TData>) =>
  useQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getPinterestAccounts({ params }, signal),
    queryKey: [queryKeys.accounts, params],
  });
